'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { twMerge } from 'tailwind-merge';
import Button from '@/ui/components/shared/Button';

export interface AddToCartButtonProps {
  isAvailable: boolean;
  onAddToCart: () => void;
  onNotify: () => void;
  /** While it is still unknown whether the visitor may buy the item. */
  disabled?: boolean;
  className?: string;
  // Replaces the default "Add to cart" text, e.g. to name the total price.
  label?: string;
}

/**
 * Primary call to action of the classic panel. It shares a row with the
 * quantity stepper, so it matches the stepper height instead of the taller
 * default button. It is deliberately not sticky: on small screens the visitor
 * scrolls past it into the details section.
 */
export function AddToCartButton({
  isAvailable,
  onAddToCart,
  onNotify,
  disabled = false,
  className,
  label,
}: Readonly<AddToCartButtonProps>) {
  const t = useTranslations('ProductChooser');

  const buttonClassName = twMerge(
    'flex h-10 items-center justify-center whitespace-nowrap py-0',
    className,
  );

  if (!isAvailable) {
    return (
      <Button className={buttonClassName} type="button" onClick={onNotify}>
        {t('Notify me')}
      </Button>
    );
  }

  return (
    <Button className={buttonClassName} type="button" onClick={onAddToCart} disabled={disabled}>
      {label ?? t('Add to cart')}
    </Button>
  );
}
